import React, { FC, useState, useEffect, useCallback } from 'react';
import { Headline3 } from '@nexus/lib-react/dist/core/Typography/Heading';
import { Paragraph2 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import { useI18n } from '../../../../i18n';
import Modal from '../../../../commons/components/Modal';
import SignalError from '../../../../commons/components/icons/SignalError';
import { SafeDealActionCommonModalProps } from '../../../../../typings/safeDealActionCommonModalProps';
import SafeDealTheme from './style/SafeDealTheme';

import S from './style/SafeDealActionDesktopModal';

const SafeDealActionDesktopModal: FC<SafeDealActionCommonModalProps> = ({
  showAcceptError,
  handleActionCancel,
  handleOnActionClick,
  trackModalVisibility,
  title,
  description,
  confirmationState,
  showRegulationsNote,
  linkTC,
}) => {
  const i18n = useI18n();
  const [responseLoading, setResponseLoading] = useState(false);

  useEffect(() => {
    if (trackModalVisibility && !showAcceptError && !responseLoading) {
      trackModalVisibility();
    }
  }, [trackModalVisibility, showAcceptError, responseLoading]);

  useEffect(() => {
    if (showAcceptError) {
      setResponseLoading(false);
    }
  }, [showAcceptError]);

  const handleBtnClick = useCallback(() => {
    handleOnActionClick();
    setResponseLoading(true);
  }, [handleOnActionClick]);

  return (
    <Modal
      title=""
      confirmLabel={
        !showAcceptError && (
          <S.ButtonContent>
            {i18n(`dlv_safedeal_confirmation_dialog_${confirmationState}_button`)}
          </S.ButtonContent>
        )
      }
      closeLabel={i18n(`dlv_safedeal_confirmation_dialog_${confirmationState}_return_button`)}
      onConfirm={!showAcceptError && handleBtnClick}
      onClose={handleActionCancel}
      inverseButtons
      loading={responseLoading}
      customWidth={SafeDealTheme.desktopModal.width}
    >
      {showAcceptError && (
        <S.IconContainer>
          <SignalError />
        </S.IconContainer>
      )}
      <Headline3
        data-testid="title"
        textAlign="center"
        paddingBottom={SafeDealTheme.desktopModal.headerPadding}
      >
        {title}
      </Headline3>
      <Paragraph2 data-testid="description" textAlign="center">
        {description}
      </Paragraph2>
      {showRegulationsNote && (
        <S.LinkButton href={linkTC} target="_blank" rel="noopener noreferrer">
          {i18n('dlv_safedeal_confirmation_dialog_reject_term_and_conditions')}
        </S.LinkButton>
      )}
    </Modal>
  );
};

export default SafeDealActionDesktopModal;
